import React from "react";
import { LuMail } from "react-icons/lu";
import contactImg from "../../assets/images/contactImg.png";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { Formik, Form } from "formik";
import PrimaryButton from "../common/PrimaryButton";
import FormikErrorMessage from "../common/FormikErrorMessage";
import EditorTextArea from "../common/EditorTextArea";
import FormikField from "../common/FormikField";

const Contact = () => {
  return (
    <div className="relative w-full">
      <img
        src={contactImg}
        className="w-full object-cover h-[calc(200vh)] sm:h-[calc(140vh)]"
        alt=""
      />

      <div className="absolute flex flex-wrap jost-regular px-4 sm:px-12 justify-between text-white items-center top-[5%] sm:top-[15%] w-full">
        <div className="flex flex-col gap-3">
          <h3 className="text-xl sm:text-2xl uppercase">Appointment</h3>
          <h1 className="text-3xl sm:text-5xl">
            Book your
            <span className="text-3xl sm:text-5xl italic ml-2 font-eiko-thin">
              Consultation
            </span>
          </h1>
        </div>
      </div>

      <div className="absolute flex flex-col gap-4 sm:gap-10 sm:flex-row jost-regular px-4 sm:px-12 justify-between text-white items-center top-[15%] sm:top-[30%] w-full">
        <div className="w-full sm:w-[50%]">
          <div className=" py-8 sm:py-12 px-4 sm:px-8 border bg-black bg-opacity-20 font-gtAmerica border-opacity-50 border-white rounded-xl sm:rounded-3xl">
            <Formik
              initialValues={{
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                query: "",
              }}
              onSubmit={(values, { setSubmitting }) => {
                console.log(values);
                setSubmitting(false);
                alert(`Thank you for subscribing, ${values.firstName}`);
              }}
            >
              {({ isSubmitting }) => (
                <Form className="flex flex-col justify-center w-full">
                  <div className="mb-8 w-full lg:grid lg:grid-cols-2 gap-4">
                    <div className="w-full">
                      <FormikField
                        type="text"
                        name="firstName"
                        id="firstName"
                        placeholder="Enter your First Name"
                        label="First Name"
                        required
                      />
                      <FormikErrorMessage name="firstName" />
                    </div>
                    <div className="w-full">
                      <FormikField
                        type="text"
                        name="lastName"
                        id="lastName"
                        placeholder="Enter Your Last Name"
                        label="Last Name"
                        required
                      />
                      <FormikErrorMessage name="lastName" />
                    </div>
                    <div className="w-full">
                      <FormikField
                        type="text"
                        name="email"
                        required
                        id="email"
                        placeholder="email@example.com"
                        label="Email"
                      />
                      <FormikErrorMessage name="email" />
                    </div>
                    <div className="w-full">
                      <FormikField
                        type="text"
                        name="phoneNumber"
                        required
                        id="phoneNumber"
                        placeholder="Enter Your Phone Number"
                        label="Phone Number"
                      />
                      <FormikErrorMessage name="phoneNumber" />
                    </div>
                    <div className="col-span-2">
                      <EditorTextArea
                        placeholder="Hello there!"
                        name="query"
                        required
                        label="Message"
                      />
                      <FormikErrorMessage name="query" />
                    </div>
                  </div>
                  <PrimaryButton
                    type="submit"
                    disabled={isSubmitting}
                    className="bg-primary text-white justify-center"
                  >
                    Send Message
                  </PrimaryButton>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <div className="sm:flex flex-col gap-4 mt-4">
          <h1 className="jost-regular text-3xl sm:text-5xl max-w-xl">
            Don’t Starve Your Mental Health
          </h1>
          <p className="max-w-2xl">
            Begin Your Mental Wellness Journey Now! Taking the first step is
            easy. Schedule an appointment with Psyche Ethos to explore
            personalized support for your mental well-being.
            <br />
            <br />
            Advisory, coaching, mentoring, or therapy—your path to clarity,
            balance, and lasting mental well-being starts here.
          </p>
          <div className="flex flex-col mt-10 gap-4">
            <div className="flex gap-4 items-center">
              <MdOutlinePhoneInTalk className="w-10 h-10 border border-white rounded-full p-1" />
              <a href="tel:+1 (234) 567 890 00" className="text-xl">
                +1 (234) 567 890 00
              </a>
            </div>
            <div className="flex gap-4 items-center">
              <LuMail className="w-10 h-10 border border-white rounded-full p-1" />
              <a href="mailto:psycheethosinfo@mail.com" className="text-xl">
                psycheethosinfo@mail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
